import { render, staticRenderFns } from "./CasaCambio.vue?vue&type=template&id=5e2e2856&scoped=true&"
import script from "./CasaCambio.vue?vue&type=script&lang=js&"
export * from "./CasaCambio.vue?vue&type=script&lang=js&"
import style0 from "./CasaCambio.vue?vue&type=style&index=0&id=5e2e2856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2e2856",
  null
  
)

export default component.exports